/* src/app/app.component.css */
@media (prefers-color-scheme: dark) {
  .user-profile-menu .p-menuitem-text,
  .user-profile-menu small {
    color: black;
  }
}
.build-info-inline {
  opacity: 0.75;
  font-size: 0.50rem;
  letter-spacing: 0.01em;
}
/*# sourceMappingURL=app.component-YQ5JJ6KJ.css.map */
